<template>
  <div  style="width: 100%;height: 100%;background: red">
    <!--        <mqjcDialog :mqjcDialog_show="mqjcDialog_show"  @changeDialogStatus="editMqjcDialogStatus"/>-->
    <iframe width="100%" height="100%" style="width: 100%;height: 100%"
            src="https://hy.cdtele.cn/guyee-dolphin/remote/jump?token=TMkhmVl7lh47dvfFLgsxM2NxPrTAUuZkNZVx8X3y51%2F5reWSXu2SlFhMwSXx1UeO"></iframe>
  </div>
</template>
<script>

export default {
  name: '',
  components: {},
  data() {
    return {}
  },
  created() {
  },
  destroyed() {
  },
  mounted() {
  },
  methods: {},
}
</script>
<style lang="less" scoped>
</style>
